import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var screenReaderOnly = /*#__PURE__*/css(["clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;"]);
export var list = /*#__PURE__*/css(["width:182px;list-style-type:none;display:flex;flex-wrap:wrap;justify-content:center;column-gap:", ";row-gap:", ";margin:0;padding:0;", ";", ";li{height:", ";}"], pxToRem(spacing.md), pxToRem(spacing.md), mediaQuery({
  min: 362
}, css(["width:auto;"])), mediaQuery({
  max: maxBreakpoints.S
}, css(["margin:", " 0;"], pxToRem(spacing.md))), pxToRem(spacing.xxl));